<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>{{ !workPermit?.id ? "Create" : "Edit" }} Work Permit</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form #form="ngForm" (ngSubmit)="onSubmit()">

  <hr class="m-0 p-0">

  <mat-dialog-content class="px-3 py-4">

    <div class="row">
      <div class="col-12 col-md-6">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Work Permit</mat-label>
          <input
            matInput
            placeholder="Work Permit"
            [(ngModel)]="workPermit.title"
            name="title"
            type="text"
            required
            #title
          />
          <mat-error *ngIf="!title.valid">Please enter a Work Permit title.</mat-error>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Industry</mat-label>
          <mat-select [(ngModel)]="workPermit.industry_id" name="industry" #industry>
            <mat-option [value]="0">All</mat-option>
            <mat-option *ngFor="let industry of industries" [value]="industry.id">{{ industry.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Description</mat-label>
        <textarea
          rows="4"
          matInput
          placeholder="Description"
          [(ngModel)]="workPermit.description"
          name="description"
          #description>
        </textarea>
    </mat-form-field>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="px-3 py-2">

    <button
      class="my-2 ml-1 mr-2"
      mat-raised-button
      [disabled]="!form.valid || inProgress"
      color="primary"
      type="submit"
      id="save"
    >
      <mat-icon>save</mat-icon>
      Save
    </button>

    <button
      type="button"
      color="warn"
      mat-icon-button
      [disabled]="!workPermit.id"
      class="dialog-remove-button my-2 ml-auto mr-1"
      (click)="onDelete()"
      matTooltip="Remove this Work Permit"
    >
      <mat-icon>delete</mat-icon>
    </button>

  </mat-dialog-actions>

</form>

